__turbopack_context__.v({
  "apply": "apply-and-reminder-module-scss-module__ll_s3a__apply",
  "apply-btn": "apply-and-reminder-module-scss-module__ll_s3a__apply-btn",
});
